import React, { useState } from 'react';
import styles from './FilmographySection.module.css';

function TypeBadge({ label }) {
  return (
    <div className={styles.badgeGradient}>
      <span style={{ fontSize: '14px', fontWeight: 600, color: '#000', background: 'linear-gradient(101.37deg, #FFD92B 0.67%, #FFB517 65.65%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{label}</span>
    </div>
  );
}

function FilmographyItem({ item, onOpen }) {
  const year = item.year ?? item.releaseYear ?? '';
  const title = item.title ?? '';
  const role = item.role ?? item.roleName ?? '';
  const mediaType = item.mediaType ?? item.genre ?? '';
  const company = item.company ?? item.platform ?? '';
  const photoCount = item.stillcutUrls?.length ?? 0;
  const youtubeUrl = item.videoUrl ?? null;

  return (
    <div className={styles.item} onClick={() => onOpen(item)} style={{ cursor: 'pointer' }}>
      <div className={styles.left}>
        <span className={styles.year}>{year}</span>
        <div className={styles.content}>
          <span className={styles.title}>{title}</span>
          {role && <span className={styles.subtitle}>{role}</span>}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.badges}>
          {mediaType && <TypeBadge label={mediaType} />}
          {company && (
            <div className={styles.badgeNormal}>
              <span className={styles.badgeText}>{company}</span>
            </div>
          )}
        </div>
        <div className={styles.icons}>
          {photoCount > 0 && (
            <div className={styles.iconBtn} title="스틸컷 보기">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="3" stroke="#555" strokeWidth="1.5"/>
                <circle cx="8.5" cy="8.5" r="1.5" fill="#555"/>
                <path d="M3 15l5-5 4 4 3-3 6 6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          )}
          {youtubeUrl && (
            <button
              className={styles.iconBtn}
              onClick={(e) => { e.stopPropagation(); window.open(youtubeUrl, '_blank'); }}
              title="영상 보기"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.45A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.45a2.78 2.78 0 001.95-1.97A29 29 0 0023 12a29 29 0 00-.46-5.58z" stroke="#555" strokeWidth="1.5"/>
                <path d="M9.75 15.02l5.75-3.02-5.75-3.02v6.04z" fill="#555"/>
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function FilmographyDetailModal({ item, onClose }) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const photos = item.stillcutUrls || [];
  const year = item.year ?? item.releaseYear ?? '';
  const title = item.title ?? '';
  const role = item.role ?? item.roleName ?? '';
  const mediaType = item.mediaType ?? item.genre ?? '';
  const company = item.company ?? item.platform ?? '';

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(560px, calc(100% - 48px))',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: '20px',
          overflow: 'hidden',
          display: 'flex', flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '24px 24px 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            {mediaType && <TypeBadge label={mediaType} />}
            {company && (
              <div className={styles.badgeNormal}>
                <span className={styles.badgeText}>{company}</span>
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, display: 'flex' }}
            aria-label="닫기"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="#090909" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div style={{ padding: '12px 24px 24px' }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>{year}</div>
          <div style={{ fontSize: '22px', fontWeight: 600, color: '#000' }}>{title}</div>
          {role && <div style={{ fontSize: '16px', color: '#666', marginTop: '4px' }}>{role}</div>}
        </div>

        {photos.length > 0 && (
          <div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 10', background: '#111' }}>
            <img
              src={photos[photoIndex]}
              alt={`${title} 스틸컷`}
              style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
            />
            {photos.length > 1 && (
              <>
                <button
                  onClick={() => setPhotoIndex((i) => (i - 1 + photos.length) % photos.length)}
                  aria-label="이전 사진"
                  style={{
                    position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
                    width: 40, height: 40, borderRadius: '50%',
                    background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.18)',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18l-6-6 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button
                  onClick={() => setPhotoIndex((i) => (i + 1) % photos.length)}
                  aria-label="다음 사진"
                  style={{
                    position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
                    width: 40, height: 40, borderRadius: '50%',
                    background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.18)',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9 6l6 6-6 6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <div style={{
                  position: 'absolute', left: '50%', bottom: 14, transform: 'translateX(-50%)',
                  minWidth: 60, height: 30, padding: '0 12px', borderRadius: 999,
                  background: 'rgba(0,0,0,0.6)', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 13, fontWeight: 600,
                }}>
                  {photoIndex + 1} / {photos.length}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FilmographySection({ works, medias }) {
  const list = works || [];
  const [openItem, setOpenItem] = useState(null);

  // FILMOGRAPHY media를 workId 기준으로 그룹핑 (작품당 여러 장 지원)
  const filmographyMediaByWorkId = {};
  (medias || [])
    .filter(m => m.photoType === 'FILMOGRAPHY' && m.workId && m.url)
    .forEach(m => {
      const key = m.workId;
      if (!filmographyMediaByWorkId[key]) filmographyMediaByWorkId[key] = [];
      filmographyMediaByWorkId[key].push(m.url);
    });

  if (list.length === 0) {
    return (
      <div className={styles.container}>
        <span className={styles.sectionTitle}>필모그래피</span>
        <div style={{ padding: '30px 0', color: '#aaa', fontSize: '16px' }}>등록된 작품이 없습니다.</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <span className={styles.sectionTitle}>필모그래피</span>
      <div className={styles.list}>
        {list.map((item, i) => {
          const groupedUrls = filmographyMediaByWorkId[item.id];
          const resolvedItem = {
            ...item,
            stillcutUrls: groupedUrls ?? (item.stillcutUrl ? [item.stillcutUrl] : []),
          };
          return (
            <FilmographyItem key={item.id ?? i} item={resolvedItem} onOpen={setOpenItem} />
          );
        })}
      </div>

      {openItem && (
        <FilmographyDetailModal item={openItem} onClose={() => setOpenItem(null)} />
      )}
    </div>
  );
}

export default FilmographySection;
